export type PublicEnv = {
  pmtilesUrl: string;
  openMeteoBaseUrl: string;
  supabaseUrl: string;
  supabasePublishableKey: string;
};

export const publicEnv: PublicEnv = {
  pmtilesUrl: readEnv("VITE_PMTILES_URL"),
  openMeteoBaseUrl: readEnv("VITE_OPEN_METEO_BASE_URL", "https://api.open-meteo.com/v1/forecast"),
  supabaseUrl: readEnv("VITE_SUPABASE_URL"),
  supabasePublishableKey: readEnv(
    "VITE_SUPABASE_PUBLISHABLE_KEY",
    readEnv("VITE_SUPABASE_ANON_KEY")
  )
};

export function hasSupabaseConfig() {
  return Boolean(publicEnv.supabaseUrl && publicEnv.supabasePublishableKey);
}

function readEnv(key: string, fallback = "") {
  const value = import.meta.env[key];
  return typeof value === "string" ? value.trim() : fallback;
}
